


















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeaderUserMenu from '@/app/components/Common/Header/HeaderUserMenu.vue'
import PlantManagerMenu from '@/app/components/Common/Header/PlantManagerMenu.vue'
import MachineManagerMenu from '@/app/components/Common/Header/MachineManagerMenu.vue'
import Local from '@/app/module/local'
import { routerPath } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    HeaderUserMenu,
    MachineManagerMenu,
    PlantManagerMenu
  }
})
export default class Header extends Vue {
  private isShowUserMenu: boolean = false
  private isShowMachineManagerMenu: boolean = false
  private isShowPlantMangerMenu: boolean = false
  private isAuth: boolean = false
  private isViewer: boolean = true
  private userName: string|null = ''
  private weedTotalCount: number = 0
  private userTypeName: string = '-'
  private constantValue: any = []
  private newsBoardTitle: string = ''

  @Watch('$store.state.weedState.totalCountFlag')
  private onDataChange (flag: boolean) {
    if (flag) {
      const data = JSON.parse(Local.getWeedAlarmCount()!)
      this.weedTotalCount = data.total_count
      this.$store.commit('weedState/setTotalCountFlag', false)
    }
  }

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    let newsBoardTitle = '栽培指導広報'
    if (CommonClass.getServiceFunctionData() !== null) {
      newsBoardTitle = CommonClass.getServiceFunctionData().news_board.news_board_name
    }
    this.newsBoardTitle = newsBoardTitle

    if (Local.getAuthToken()) {
      this.isAuth = true
    }

    const data = JSON.parse(Local.getWeedAlarmCount()!)
    if (data !== null) {
      this.weedTotalCount = data.total_count
    }

    if (Local.getUserName()) {
      this.userName = Local.getUserName()
    } else {
      this.userName = '名無し'
    }
    this.jugeUserType()
  }

  private jugeUserType () {
    const userType = parseInt(Local.getUserType()!)
    this.constantValue = JSON.parse(Local.getConstantValue()!)

    if (this.constantValue === null) {
      setTimeout(this.jugeUserType, 200)
      return
    }

    // 閲覧者の場合は圃場マップとユーザー情報のみ表示
    if (userType === 5) {
      this.isViewer = true
    } else {
      this.isViewer = false
    }

    // ユーザー情報の
    const userTypeData = this.constantValue.user_types.filter((data: any) => data.user_type_id === userType)
    if (userTypeData.length === 0) {
      this.userTypeName = '-'
    } else {
      this.userTypeName = userTypeData[0].user_type_name
    }
  }

  private showMachineManagerMenu () {
    if (this.isShowMachineManagerMenu) {
      this.isShowMachineManagerMenu = false
    } else {
      this.isShowMachineManagerMenu = true
      this.isShowPlantMangerMenu = false
      this.isShowUserMenu = false
    }
  }
  private showPlantManagerMenu () {
    if (this.isShowPlantMangerMenu) {
      this.isShowPlantMangerMenu = false
    } else {
      this.isShowPlantMangerMenu = true
      this.isShowMachineManagerMenu = false
      this.isShowUserMenu = false
    }
  }
  private showUserMenu () {
    if (this.isShowUserMenu) {
      this.isShowUserMenu = false
    } else {
      this.isShowUserMenu = true
      this.isShowMachineManagerMenu = false
      this.isShowPlantMangerMenu = false
    }
  }

  private isActive (key: string) {
    // マップ・圃場一覧
    switch (key) {
      case 'map':
        if (this.$route.path === routerPath.PATH_FIELD) {
          return true
        }
        break

      case 'news-board':
        if (this.$route.path === routerPath.PATH_NEWS_BOARD ||
            this.$route.path === routerPath.PATH_NEWS_BOARD_CREATE ||
            this.$route.path.indexOf(routerPath.PATH_NEWS_BOARD) === 0) {
          return true
        }
        break

      case 'cam-image':
        if (this.$route.path === routerPath.PATH_CAM_IMAGE) {
          return true
        }
        break

      case 'mypage':
        if (this.$route.path === routerPath.PATH_MY_PAGE) {
          return true
        }
        break

      case 'master':
        if (this.$route.path.indexOf(routerPath.PATH_MASTER) === 0 ||
            this.$route.path.indexOf(routerPath.PATH_EXTERNAL_LINKAGE) === 0) {
          return true
        }
        break

      case 'header-plant-manager':
        if (this.$route.path === routerPath.PATH_PLANT_LIST ||
            this.$route.path === routerPath.PATH_FIELD_ORDER ||
            this.$route.path === routerPath.PATH_PROFIT ||
            this.$route.path === routerPath.PATH_PLANT_CREATE ||
            this.$route.path.indexOf(routerPath.PATH_PLANT_LIST) === 0) {
          return true
        }
        break

      case 'header-machine-manager':
        if (this.$route.path === routerPath.PATH_MACHINE_RENT ||
            this.$route.path === routerPath.PATH_WEED_LIST ||
            this.$route.path === routerPath.PATH_MACHINE_RENT_CREATE ||
            this.$route.path.indexOf(routerPath.PATH_MACHINE_RENT) === 0) {
          return true
        }
        break

      default:
        break
    }
  }

  private stringCut (data: string) {
    if (data !== '' && data !== undefined) {
      if (data.length > 15) {
        return data.substr(0, 14) + '…'
      } else {
        return data
      }
    }
  }

  private closePulldown () {
    this.isShowMachineManagerMenu = false
    this.isShowPlantMangerMenu = false
    this.isShowUserMenu = false
  }
}
